import type { PublicSlotKey } from '#packages/apilib';
import type { StageContextApi } from './stageContextApi';

export const StageContextApiKey: PublicSlotKey<StageContextApi> = {
  name: 'StageContextApi',
  public: true,
};
